export default __webpack_public_path__ + "static/752-4276aeb4ab570f001287da37d61f9fb3.gif";